import React from "react";
import { Link } from "react-router-dom";
import SEO from "./SEO";
import Google_review from "../assets/Google_Review_For_Website.png";
import pathyacharyaWeb from "../assets/website/pathyacharya_web.jpg";
import KumarUjjvalReview from "../assets/vernacular_page/KumarUjjvalReview.png";
import SagarKumarReview from "../assets/vernacular_page/SagarKumarReview.png";
import DhirajKumarReview from "../assets/vernacular_page/DhirajKumarReview.png";

import PhoneCaptureForm from "./funnel/PhoneCaptureForm";
import TrustStrip from "./funnel/TrustStrip";
import StatsBlock from "./funnel/StatsBlock";
import ScreenshotCarousel from "./funnel/ScreenshotCarousel";
import KunjiHighlight from "./funnel/KunjiHighlight";
import PricingBlock from "./funnel/PricingBlock";
import TopperGrid from "./funnel/TopperGrid";
import FAQ from "./funnel/FAQ";
import { buildPlayStoreUrl } from "./funnel/utm";
import PlayStoreCTA from "./funnel/PlayStoreCTA";

const boards = [
  { name: "CBSE", short: "CBSE", slug: "cbse-board" },
  { name: "BSEB (बिहार बोर्ड)", short: "BSEB", slug: "bihar-board" },
  { name: "UPMSP (UP बोर्ड)", short: "UPMSP", slug: "up-board" },
  { name: "JAC (झारखंड बोर्ड)", short: "JAC", slug: "jharkhand-board" },
  { name: "MPBSE (MP बोर्ड)", short: "MPBSE", slug: "mp-board" },
  { name: "RBSE (राजस्थान बोर्ड)", short: "RBSE", slug: "rajasthan-board" },
  { name: "CGBSE (छत्तीसगढ़ बोर्ड)", short: "CGBSE", slug: "chhattisgarh-board" },
  { name: "UBSE (उत्तराखंड बोर्ड)", short: "UBSE", slug: "uttarakhand-board" },
  { name: "HBSE (हरियाणा बोर्ड)", short: "HBSE", slug: "haryana-board" },
  { name: "NCERT", short: "NCERT" },
];

const features = [
  {
    title: "वीडियो लेक्चर्स",
    desc: "हिंदी में सभी विषयों के video lectures - अनुभवी शिक्षकों द्वारा",
    icon: "🎥",
  },
  {
    title: "AI Doubt Solving (कुंजी AI)",
    desc: "किसी भी सवाल का तुरंत जवाब - फोटो खींचो, जवाब पाओ",
    icon: "🤖",
  },
  {
    title: "डेली क्विज़",
    desc: "रोज़ाना practice quizzes से परीक्षा की तैयारी करें",
    icon: "📝",
  },
  {
    title: "ऑफलाइन मोड",
    desc: "बिना internet के भी पढ़ाई करें - videos download करें",
    icon: "📱",
  },
];

const reviews = [
  { src: KumarUjjvalReview, alt: "Kumar Ujjval Review" },
  { src: SagarKumarReview, alt: "Sagar Kumar Review" },
  { src: DhirajKumarReview, alt: "Dhiraj Kumar Review" },
];

const Pathyacharya = () => {
  const heroPlayStoreUrl = buildPlayStoreUrl({
    medium: "pathyacharya_hero",
    term: "play-badge",
  });
  const finalPlayStoreUrl = buildPlayStoreUrl({
    medium: "pathyacharya_final_cta",
    term: "play-badge",
  });

  return (
    <div className="mt-[100px]">
      <SEO
        title="पाठ्यचर्या (Pathyacharya) - बिहार बोर्ड, UP बोर्ड परीक्षा तैयारी ऐप | हिंदी में पढ़ाई"
        description="पाठ्यचर्या ऐप से करें बिहार बोर्ड, UP बोर्ड, झारखंड बोर्ड परीक्षा की तैयारी हिंदी में। 20,000+ video lectures, AI doubt solving, daily quizzes। 7 दिन का free trial — फिर ₹599/year से।"
        url="https://schooglink.com/pathyacharya"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          name: "Pathyacharya",
          operatingSystem: "Android",
          applicationCategory: "EducationalApplication",
          offers: {
            "@type": "AggregateOffer",
            lowPrice: "99",
            highPrice: "599",
            priceCurrency: "INR",
            offerCount: 3,
            offers: [
              {
                "@type": "Offer",
                name: "Monthly Subscription",
                price: "99",
                priceCurrency: "INR",
                priceSpecification: {
                  "@type": "UnitPriceSpecification",
                  price: "99",
                  priceCurrency: "INR",
                  referenceQuantity: {
                    "@type": "QuantitativeValue",
                    value: "1",
                    unitCode: "MON",
                  },
                },
              },
              {
                "@type": "Offer",
                name: "Quarterly Subscription",
                price: "249",
                priceCurrency: "INR",
                priceSpecification: {
                  "@type": "UnitPriceSpecification",
                  price: "249",
                  priceCurrency: "INR",
                  referenceQuantity: {
                    "@type": "QuantitativeValue",
                    value: "3",
                    unitCode: "MON",
                  },
                },
              },
              {
                "@type": "Offer",
                name: "Yearly Subscription",
                price: "599",
                priceCurrency: "INR",
                priceSpecification: {
                  "@type": "UnitPriceSpecification",
                  price: "599",
                  priceCurrency: "INR",
                  referenceQuantity: {
                    "@type": "QuantitativeValue",
                    value: "1",
                    unitCode: "ANN",
                  },
                },
              },
            ],
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4.5",
            ratingCount: "1000",
          },
          description:
            "Hindi medium learning app for Bihar Board, UP Board, Jharkhand Board exam preparation with video lectures and AI doubt solving.",
        }}
      />

      {/* Hero */}
      <section className="bg-gradient-to-b from-blue-50 to-white py-12 px-4">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-block bg-yellow-100 border border-yellow-400 rounded-full px-3 py-1 mb-4">
              <p className="text-xs sm:text-sm font-bold text-yellow-800">
                7 दिन का Free Trial · No credit card
              </p>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-snug">
              <span className="block">पाठ्यचर्या ऐप से करें</span>
              <span className="block text-blue-600 mt-2">बोर्ड परीक्षा की तैयारी</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-700 mt-4">
              हिंदी में 20,000+ video lectures, AI doubt solving, और daily
              quizzes के साथ Class 6 से 12 तक की पढ़ाई।
            </p>

            <div className="mt-6 flex flex-col items-center lg:items-start gap-4">
              <PhoneCaptureForm source="pathyacharya_hero" />
              <div className="flex flex-col sm:flex-row sm:items-center gap-3 items-center lg:items-start">
                <span className="text-xs text-gray-500">या सीधे install करें:</span>
                <PlayStoreCTA href={heroPlayStoreUrl} />
              </div>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <img
              src={pathyacharyaWeb}
              alt="Pathyacharya App Screenshot"
              className="max-w-sm w-full"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <TrustStrip />
      <StatsBlock />
      <ScreenshotCarousel />

      {/* Features */}
      <section className="py-12 px-4 bg-blue-50">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8">
            ऐप की खास बातें
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="bg-white rounded-xl p-6 shadow-sm border border-gray-100"
              >
                <div className="text-4xl mb-3">{feature.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Supported Boards */}
      <section className="py-12 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8">
            सभी प्रमुख बोर्ड की पढ़ाई एक ऐप में
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {boards.map((board) =>
              board.slug ? (
                <Link
                  key={board.short}
                  to={`/${board.slug}`}
                  className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center font-semibold text-gray-800 hover:shadow-md hover:border-blue-300 hover:bg-blue-50 transition-all"
                >
                  {board.name}
                </Link>
              ) : (
                <div
                  key={board.short}
                  className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center font-semibold text-gray-800"
                >
                  {board.name}
                </div>
              )
            )}
          </div>
        </div>
      </section>

      <KunjiHighlight />
      <PricingBlock />
      <TopperGrid />

      {/* Student Reviews (existing assets) */}
      <section className="py-12 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8">
            छात्रों की राय
          </h2>
          <div className="flex justify-center mb-6">
            <img
              src={Google_review}
              alt="Google Play Store Rating"
              className="h-16"
              loading="lazy"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {reviews.map((review) => (
              <div key={review.alt} className="flex justify-center">
                <img
                  src={review.src}
                  alt={review.alt}
                  className="rounded-lg shadow-md max-w-full"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <FAQ />

      {/* Final CTA */}
      <section className="py-14 px-4 bg-blue-600 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold mb-3">
            अभी पाठ्यचर्या से पढ़ाई शुरू करें
          </h2>
          <p className="text-lg mb-6 text-blue-100">
            7 दिन का free trial — पसंद आए तभी subscribe करें।
          </p>
          <div className="flex justify-center mb-6">
            <PhoneCaptureForm
              source="pathyacharya_final_cta"
              ctaLabel="मुझे call back करें"
              successLabel="Done — हमारी टीम जल्द call करेगी।"
              helperLabel="हम call करके guide करेंगे, spam नहीं भेजेंगे।"
            />
          </div>
          <div className="text-blue-100 text-sm mb-3">— या —</div>
          <PlayStoreCTA
            href={finalPlayStoreUrl}
            badgeClassName="h-14 sm:h-16"
            qrSize="w-24 h-24"
            className="justify-center"
          />
        </div>
      </section>
    </div>
  );
};

export default Pathyacharya;
